import { environment } from '../../../environments/environment';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { map, shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LabelsService {
  private baseUrl = environment.apiUrl+'/labels';

  constructor(
    private http: HttpClient,
    private translate: TranslateService
  ) {}
     loadAndMerge(lang: string){
        
      return this.http.get<Record<string, any>>(`${this.baseUrl}/${lang}.json`, {
        headers: { 'Accept': 'application/json' }
        }).pipe(shareReplay(),map(remote =>{
          this.translate.setTranslation(lang, remote, true);
          return true;
      }));
        
    }

}